module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_05-4a0ed050bd7258c53de75c36a6fa8734.png";